import { AddressType } from "@affinity/constants/SharedTypes";
import addAddress from "@affinity/Handlers/AddAddress";
import AddAddress from "@affinity/Handlers/AddAddress";
import LoadAddresses from "@affinity/Handlers/LoadAddresses";
import setAddress from "@affinity/Handlers/SetAddress";
import { CustomState } from "@affinity/Store/Reducers";
import AddressesSelector from "@affinity/Widgets/PlaceOrder/AddressesSelector";
import setInitialValues from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    // Map required state elements to component properties
    isAuthenticated: state.context.session.isAuthenticated,
    phone: state.affinity_create_account.contactNumber,
    currentUserId: state.context.session.userProfileId,
    currentBillTo: state.affinity_create_account.billTo, // DO NOT USE CONTEXT IT WILL NOT HAVE UPDATED
});

const mapDispatchToProps = {
    // Map loader and setter methods to component properties
    setAddress,
    addAddress,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const Step2Addresses: React.FC<Props> = ({ 
    phone, 
    isAuthenticated,
    setAddress,
    currentUserId,
    currentBillTo, 
    addAddress,
}) => {

    const onAddAddress = (value: AddressType) => {
        addAddress({
            currentUserId: currentUserId!,
            billToId: currentBillTo?.id,
            phone: phone ?? '',
            ...value
        });
    };

    const onAddressSelect = (address: ShipToModel) => {
        setAddress({
            shipTo: address,
        });
    };

    return <AddressesSelector onAddAddress={onAddAddress} onAddressSelect={onAddressSelect} />;
};

export function combineAddress(address: ShipToModel) {
    return [
        address.address1,
        address.address2,
        address.address3,
        address.city,
        address.address4,
        // address.postalCode,
    ]
        .filter(elm => elm)
        .join(", ");
}

export default connect(mapStateToProps, mapDispatchToProps)(Step2Addresses);
